<template>
  <CBox>
    <CBox class="photoBox" ml="auto" mr="auto" mt="7vw" w="12.5vw">
      <CImage
        id="animate"
        class="photo"
        size="12.5vw"
        data-aos="swirl-out-bck"
        data-aos-duration="550"
        :data-aos-offset="getOffset"
        rounded="full"
        :src="getAvatarImage"
        alt="Kishan Photo!"
      />
    </CBox>
  </CBox>
</template>

<script>
import { CBox, CImage } from "@chakra-ui/vue";
import AvatarImage from "../assets/img/avatar.jpg";

export default {
  name: "ProfilePicture",
  computed: {
    getAvatarImage() {
      return AvatarImage;
    },
    getOffset() {
      return (window.innerHeight / 100) * 100;
    },
  },
  components: {
    CBox,
    CImage,
  },
};
</script>

<style>
@media screen and (max-width: 480px) {
  .photoBox {
    margin-top: 15vh;
    width: 15vh;
  }
  .photo {
    width: 15vh;
    height: 15vh;
  }
}

[data-aos="swirl-out-bck"] {
  transform: rotate(0) scale(1);
  opacity: 1;
}

[data-aos="swirl-out-bck"].aos-animate {
  transform: rotate(-720deg) scale(0);
  opacity: 0;
}
</style>
